import React from 'react';
import { ICONS } from '../../constants';
import Button from './Button';
import Modal from './Modal';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'danger' | 'warning' | 'info';
  itemName?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Подтвердить',
  cancelText = 'Отмена',
  type = 'danger',
  itemName
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return <ICONS.Trash className="w-12 h-12 text-red-500 mx-auto mb-4" />;
      case 'warning':
        return <div className="w-12 h-12 text-yellow-500 mx-auto mb-4 flex items-center justify-center">⚠️</div>;
      case 'info':
        return <div className="w-12 h-12 text-blue-500 mx-auto mb-4 flex items-center justify-center">ℹ️</div>;
      default:
        return <ICONS.Trash className="w-12 h-12 text-red-500 mx-auto mb-4" />;
    }
  };

  const getConfirmButtonVariant = () => {
    switch (type) {
      case 'danger':
        return 'danger';
      case 'warning':
        return 'primary';
      case 'info':
        return 'primary';
      default:
        return 'danger';
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="">
      <div className="text-center py-4">
        {getIcon()}
        
        <h3 className="text-xl font-bold text-white mb-4">
          {title}
        </h3>
        
        {itemName && (
          <div className="bg-gray-700 rounded-lg p-3 mb-4">
            <p className="text-gray-300 text-sm mb-1">Элемент для удаления:</p>
            <p className="text-white font-semibold">{itemName}</p>
          </div>
        )}
        
        <p className="text-gray-300 mb-6 leading-relaxed">
          {message}
        </p>
        
        <div className="flex space-x-4 justify-center">
          <Button
            variant="secondary"
            onClick={onClose}
            className="px-6 py-2"
          >
            {cancelText}
          </Button>
          <Button
            variant={getConfirmButtonVariant() as any}
            onClick={handleConfirm}
            className="px-6 py-2"
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
